import { render, staticRenderFns } from "./AccountResumeModal.vue?vue&type=template&id=afa1316a"
import script from "./AccountResumeModal.vue?vue&type=script&lang=js"
export * from "./AccountResumeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports